import {
  BaseFieldWidget,
  BaseTableFieldWidget,
  BaseTableFieldWidgetProps,
  ModelFieldType,
  RowContext,
  RuntimeModelField,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Table,
    ttype: ModelFieldType.Float,
    widget: 'OrderPlanCol',
    multi: false
  })
)
export class TableFloatOrderPlanColFieldWidget extends BaseTableFieldWidget {
  @Widget.Method()
  editorValidateConfirm(context: RowContext<unknown>): Promise<boolean> {
    if (Number(context.data.itemPurchasingNum as string) > Number(context.data.unPurchasingTotalNum || 0)) {
      OioNotification.error('提示', `商品(${context.data.itemOutCode})的要货数量不可大于可要货数量`);
      return Promise.resolve(false);
    }
    return super.editorValidateConfirm(context);
  }
}
